import React, { useState, useEffect } from "react";
import "../App.css";

import Axios from "axios";
import {useNavigate} from "react-router-dom";

import {MDBBtn, MDBInput} from "mdb-react-ui-kit";

import 'react-datepicker/dist/react-datepicker.css'
import {backendPathAuth, backendPathPartners} from "../Constants";
import TopNavbar from "../components/Navbar";
import {loadPermissions} from "../functions/permissions";



function NewPartner() {
    const navigate = useNavigate();

    const [name, setName] = useState("");
    const [submitted, setSubmitted] = useState(false);

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);


    const addPartner = () => {
        setSubmitted(true);

        if (!name) {
            return;
        }

        Axios.get(backendPathPartners+"create-partner.php", {
            params: {
                name: name,
            }
        }).then(() => {
            console.log(name);
            navigate("/partners");
        });
    };

    useEffect(() => {
        loadPermissions(navigate, setReadPermission, setWritePermission);
    }, []);


    return (
        <div>
            <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>
            <div className="main">
                <div className="header">
                    <h2>Neuen Partner hinzufügen</h2>
                </div>
                
                <div className='input-form'>

                    <MDBInput className="input" label='Name' id='form1' type='text' onChange={(event) => {
                        setName(event.target.value);
                    }} />
                    {(submitted && !name)?
                        <p className="validation-label">Name darf nicht leer sein.</p> : null
                    }

                </div>

                <div className="footer">
                    <MDBBtn className="btn" type="submit" onClick={addPartner}>Speichern</MDBBtn>
                </div>

            </div>
        </div>
    );
}

export default NewPartner;